import { ConnectedCrmIntegration } from "@/hooks/useConnectedCrmIntegrations";
import { cn } from "@/lib/utils";

type ConnectedCrmLogosProps = {
  integrations: readonly ConnectedCrmIntegration[];
  className?: string;
};

/**
 * The logos of every CRM the team has connected, side by side.
 *
 * The sync triggers used to fall back to a neutral chain icon as soon as a
 * second CRM was connected: it named neither of them, and it read as a second
 * copy of the green "linked" badge sitting right next to it. Showing both logos
 * says which CRMs the button talks to, and leaves the linked state to the badge.
 */
export const ConnectedCrmLogos = ({
  integrations,
  className,
}: ConnectedCrmLogosProps) => (
  <span className={cn("flex gap-1 items-center shrink-0", className)}>
    {integrations.map((integration) => (
      <img
        key={integration.key}
        src={integration.logo}
        alt={integration.name}
        className="object-contain shrink-0 w-4 h-4"
      />
    ))}
  </span>
);
